import '@styles/components/appCivilStationDesigner.less';

const AppCivilStationDesigner = () => {
  return (
    <div className={'app-display-desc'}>
      <div>
        <div className={'content-introduction'}>
          设计大师 CivilStation Designer（简称 CSD
          ）面向土木交通行业桥梁、隧道、路基、地质、互通、交安、接触网等专业的正向BIM设计软件。利用参数化功能快速进行BIM三维设计，实现模型计算分析、工程量统计。CSD
          可将设计模型直接转换为施工模型，一键发布
          GIS。目前，CSD已在国内外多个大中型公路、市政、铁路工程中应用。
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>桥梁设计</p>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          基于桩号、高程定位，具备专业的桥梁参数化设计建模能力。内置桥梁上、下部参数化构件库，可快速进行方案、详细设计阶段的桥梁三维设计，分类统计桥梁工程数量，并可与有限元分析软件Midas等对接，通过桥梁大师实现出图。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/csd_01.png').default} alt="" />
          <p className={'qldsimgj'}>桥梁设计</p>
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <span className={'text'}>互通设计</span>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          支持OpenRoads设计互通路线，也可导入纬地、EICAD、金思路等软件的平面、纵断面、横断面宽度、超高横坡数据生成完整的路线模型，并基于路线模型一键绘制偏执线，支持交互/自动的形式绘制连接部模型并处理变速车道和渐变段偏执线。同时，用户可以灵活设计构造物布置方案或导入已有的方案，进而快速创建互动立交路基、桥梁模型，可一键智能处理连接部位置路基及桥梁结构的过渡，生成完整的互通立交模型。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/csd_02.png').default} alt="" />
          <p className={'qldsimgj'}>互通设计</p>
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>地质设计</p>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          通过钻孔数据、试验数据、钻孔模型、剖面图、地质建模、辅助工具（物理力学统计赋值、赤平投影等）、工程计算，勘察出表出图等实现地质勘察解决方案。结合地质进行路桥隧结构设计，可根据地质模型生成虚拟钻孔，为重要工点施工提供指导，并可根据地质纵断面快速生成沿线地质三维模型，同时对岩性进行岩体材质贴图，支持结构面、断层、透镜体等精细地质构造的建模，坐标系基于大地绝对坐标系。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/dzsj.gif').default} alt="" />
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <span className={'text'}>隧道设计</span>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          可快速完成主洞、明洞、横通道等各种设施的参数化设计，能够很好地解决横通道设计以及其与主洞的裁剪。可快速完成隧道锚杆及钢架设计、建模。并能快速完成隧道洞口边坡、仰坡、回填、洞门等设计。支持削竹式、端墙式、半明洞式等洞口形式。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/sdcsh.gif').default} alt="" />
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>路基设计</p>
          <span className={'line'} />
        </div>
        <div className={'introduce'}>
          支持参数化路基断面设计，可一键布置分离式路基、支挡结构交互式设计、坡面防护批量设计、一键地基加固设计、工程量快速统计。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ljsj.gif').default} alt="" />
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <span className={'text'}>交安设计</span>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          实现快速参数化设计，包括标志、标线、护栏及其他常用沿线结构物，如隔离栅、防落网、路灯、绿植、收费站等结构物模型，并自定义扩充。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/jasj.gif').default} alt="" />
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>接触网及轨道设计</p>
          <span className={'line'} />
        </div>
        <div className={'introduce'}>
          具备区间、锚段、参考柱线、柱子、悬挂系统总体设计电缆的模拟和分析，区间批量化设计，场站交互设计功能。具备轨道部件库，可进行全线灵活分段设计，支持轨道模型的快速建立。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/jcw.gif').default} alt="" />
        </div>
      </div>
      <div className={'bg-color'} style={{ marginBottom: '0px' }}>
        <div className={'content-title'}>
          <span className={'text'}>施工模型深化</span>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          可根据具体设计信息，在三维设计过程中自动创建模型结构树，方便模型管理。模型快速轻量化，一键发布到GIS+BIM可视化施工管理平台，进行模型及设计信息GIS端快速浏览。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/csd_13.png').default} alt="" />
          <p className={'qldsimgj'}>结构树及模型属性挂接</p>
        </div>
      </div>
    </div>
  );
};

export default AppCivilStationDesigner;
